module.exports = __webpack_public_path__ + "img/DiscrepancyTreemapType.9dcdf276.png";